// extracted by mini-css-extract-plugin
export default {"header":"TableHeadContainer_header__0PovL"};